export default class ModListing {
  constructor(el) {
    this.$el = $(el)

    this.dom = {
      $select: this.$el.find('.select-c8'),
      $cards: this.$el.find('.mod-listing__card'),
      $readMore: this.$el.find('.js-read-more-btn'),
      $grid: this.$el.find('.mod-listing__grid'),
    }
    this.classes = {
      hidden: 'hidden',
      filterResult: '.mod-listing',
      listingGrid: '.mod-listing__grid',
    }

    this.options = {
      all: 'all',
      video: 'video',
      blog: 'blog',
    }

    this.filterParams = []
    this.clearing = false
    this.isLoadMore = false
    this.isLoading = false
  }

  init() {
    this.addEventListener()
  }

  addEventListener() {
    this.dom.$select.on('change', (_) => {
      this.isLoadMore = false
      this.isLoading = true
      this.updateFilterParams(1, '')
    })

    this.dom.$readMore.on('click', (e) => {
      this.isLoadMore = true
      this.isLoading = true
      this.updateFilterParams(e.target.dataset.page, '')
    })
  }

  updateFilterParams(page, value) {
    this.searchParams = new URLSearchParams('')
    this.filterParams = []
    // if (value === this.options.all) {
    //   this.dom.$cards.removeClass(this.classes.hidden)
    //   return
    // }

    // const type = value.toLowerCase().includes(this.options.video) ? this.options.video : this.options.blog
    // this.dom.$cards.each((_, card) => {
    //   const $card = $(card)
    //   if ($card.data('type') === type) {
    //     $card.removeClass(this.classes.hidden)
    //   } else {
    //     $card.addClass(this.classes.hidden)
    //   }
    // })

    if (value) {
      this.searchParams.set('keyword', value)
      this.filterParams.push({
        key: 'keyword',
        value,
      })
    }

    if (page > 0) {
      this.searchParams.set('page', page)
      this.filterParams.push({
        key: 'page',
        value: page,
      })
    }

    this.dom.$select.each((_, select) => {
      const $select = $(select)
      const valueSelect = $select.val()
      if (valueSelect) {
        this.filterParams.push({
          key: $select.attr('name'),
          value: valueSelect,
        })
        this.searchParams.set($select.attr('name'), valueSelect)
      }
    })

    this.filterParams.push({
      key: 'post_per_page',
      value: this.$el.find(this.classes.filterResult).data('post-per-page'),
    })

    const newUrl = this.searchParams.toString()
      ? `${window.location.pathname}?${this.searchParams.toString()}`
      : window.location.pathname

    window.history.pushState(null, '', newUrl)

    this.callAjax()
  }

  callAjax() {
    if (!this.clearing) {
      const action = this.$el.find(this.classes.filterResult).data('action')

      $.ajax({
        url: window.AJAX_URL,
        type: 'POST',
        data: {
          action,
          filterParams: this.filterParams,
          isLoadMore: this.isLoadMore,
        },
        beforeSend: () => {
          if (this.isLoading) {
            $('.filter-loading').fadeIn(500)
          }
        },
        success: (response) => {
          $('.filter-loading').fadeOut(500)
          const $responseHtml = $(response)
          const $newReadMoreBtn = $responseHtml.find('.js-read-more-btn')
          if (this.isLoadMore) {
            // Append new cards to the grid
            this.dom.$grid.append($responseHtml)

            // Update or remove the read more button
            if ($newReadMoreBtn.length) {
              this.dom.$readMore.parent().remove()
              this.dom.$readMore = $newReadMoreBtn
              this.dom.$readMore.on('click', (e) => {
                this.isLoadMore = true
                this.isLoading = true
                this.updateFilterParams(e.target.dataset.page, '')
              })
            } else {
              // No more posts to load, remove the button
              this.dom.$readMore.parent().remove()
            }
          } else {
            if ($newReadMoreBtn.length) {
              this.dom.$readMore.remove()
              this.dom.$readMore = $newReadMoreBtn
            }

            // For filter changes, replace the entire content
            this.dom.$grid.html($responseHtml)
            // Update DOM references after content replacement
            this.dom.$readMore = this.$el.find('.js-read-more-btn')

            // Re-attach event listener to the new read more button

            this.dom.$readMore.off('click').on('click', (e) => {
              this.isLoadMore = true
              this.isLoading = true
              this.updateFilterParams(e.target.dataset.page, '')
            })
          }
          // Check if is_get_page_before parameter is present in URL
          // $('html, body').stop().animate(
          //   {
          //     scrollTop: $(document).find(this.$el).height() - $('.header').height() + 100,
          //   },
          // )
          this.isLoading = false
        },
        error: () => {
          $('.filter-loading').fadeOut(500)
          if (this.isLoadMore) {
            this.dom.$readMore.prop('disabled', false).text('Try Again')
          }
        },
      })
    }
  }
}

const $modListing = $('.mod-listing')
if ($modListing.length) {
  $modListing.each((_, element) => {
    new ModListing(element).init()
  })
}
